// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"8cbffe35","424":"a7121728","472":"01e0ca3a","728":"f264f663","748":"db65f003"}[chunkId] + ".chunk.js";
};